import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedmineConnectComponent } from './redmine-connect.component';
import { IssueModalComponent } from './issue-modal/issue-modal.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ThemeConstants } from '../shared/config/theme-constant';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [CommonModule, SharedModule, NgSelectModule],
  declarations: [RedmineConnectComponent, IssueModalComponent],
  exports: [IssueModalComponent],
  providers: [ThemeConstants],
})
export class RedmineConnectModule {}
